"use strict";

emailBlast.classy.controller({
    name: "ConfirmModalController",
    inject: ["$scope", "$http", "authServiceFactory", "DateService", "$modalInstance", "recipients", "email"],
    init: function() {
        this.$.$modalInstance = this.$modalInstance;
        this.$.currentYear = this.DateService.getCurrentYear();
        this.$.recipients = this.recipients;
        this.$.sendclick = true;
    },
    send: function(instance) {
        this.$http.post("/api/school/" + this.authServiceFactory.getAuth().schoolID + "/EmailBlastSend", this.email)
            .then(() => { // success
                swal({
                    title: "Success",
                    text: "Your email blast has been processed and will send momentarily",
                    type: "success"
                });
                this.$modalInstance.close();
            }, () => { // error
                instance.stop(-1);
                swal({
                    title: "Error",
                    text: "An error occured while processing your email blast",
                    type: "error"
                });
            });
    }
});
